import { ApplicationTargetEnum } from '~types/app-selection';
import { RED_600, WHITE } from '~styles/colors';
import type { PreviewTheme } from './tokens';

/**
 * Couche-Tard (Quebec) preview theme.
 *
 * Brand color (`RED_600` / `#c60a0d`) matches the Figma `--Primary-6`
 * token used in the App preview frame (CT - Conception UI - CMS,
 * node 12404-17237).
 *
 * Bottom-tab order matches the new home design: Carwash is shown only
 * in QC.
 */
export const qcTheme: PreviewTheme = {
    region: ApplicationTargetEnum.QC,
    colors: {
        primary: RED_600,
        primaryContrast: WHITE,
    },
    logo: {
        id: 'CT',
    },
    tabs: ['home', 'map', 'products', 'carwash', 'more'],
};
